/* eslint-disable no-nested-ternary */
import React from 'react';

import LevelEsencialVertical from '@crehana/icons/dist/LevelEsencialVertical';
import LevelIntermediateVertical from '@crehana/icons/dist/LevelIntermediateVertical';
import LevelCompleteVertical from '@crehana/icons/dist/LevelCompleteVertical';
import LevelCompleteCircle from '@crehana/icons/dist/LevelCompleteCircle';
import { primaryColor } from '@crehana/ui/dist/styles/colors';

import type { CourseCardProps } from '../../types';

export const courseType = (typeLevel: string) => {
  if (typeLevel.toLowerCase() === 'completo') {
    return <LevelCompleteCircle size={19} color={primaryColor} />;
  }
  if (
    typeLevel.toLowerCase() === 'esencial' ||
    typeLevel.toLowerCase() === 'introductorio'
  ) {
    return <LevelEsencialVertical size={24} color={primaryColor} />;
  }
  if (typeLevel.toLowerCase() === 'intermedio') {
    return <LevelIntermediateVertical size={24} color={primaryColor} />;
  }
  if (typeLevel.toLowerCase() === 'avanzado') {
    return <LevelCompleteVertical size={24} color={primaryColor} />;
  }
};

const Level: React.FC<Partial<CourseCardProps>> = props => {
  const { level } = props;
  const levelName = level && level.name && level.name.toLowerCase();

  if (!levelName) {
    return null;
  }

  return (
    <div
      className="LevelComponent flex items-center"
      css={`
        padding: ${levelName ? '18px 0 12px' : '14px 0 12px'};
      `}
    >
      <div className="flex items-center">
        {courseType(levelName)}
        <p className="font-body4 text-gray-dark tw-font-semibold ml-8">
          {`${
            levelName === 'completo'
              ? 'Completo'
              : `Nivel ${
                  levelName === 'esencial'
                    ? 'Introductorio'
                    : level && level.name
                }`
          }`}
        </p>
      </div>
    </div>
  );
};

export default Level;
